const EMAIL_TEMPLATE_MODE_FOR_PARAMS = {
  DRAG_DROP_EMAIL: 'drag_drop_email',
  CLASSIC_EMAIL: 'classic_email'
};
export default EMAIL_TEMPLATE_MODE_FOR_PARAMS;